import React, { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import AdunitApiService from '../../ApiServices/AnalyticsApiService/AdunitApiService';

const AddAdunitForm = ({ isOpen, onRequestClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        name: '', // Adunit Name
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const adunitData = {
                id: parseInt(formData.id), // Ensure ID is a number
                name: formData.name.trim(),
            };

            await AdunitApiService.create(adunitData);
            toast.success('Adunit created successfully!');
            onSubmit(); // Trigger parent callback
            onRequestClose();
        } catch (error) {
            setError(error.message || 'Failed to add Adunit');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onRequestClose} className="flex items-center justify-center min-h-screen p-4 animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-xl p-8 max-w-3xl w-full relative max-h-[90vh] overflow-hidden flex flex-col transition-all transform hover:scale-105 duration-300">
                {/* Close Button */}
                <button onClick={onRequestClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
                    ✖
                </button>

                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-700 text-center mb-4">Add Adunit</h2>

                {error && <p className="text-red-500 mb-3 text-center">{error}</p>}

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-600 font-medium">Adunit Name</label>
                        <input
                            name="name"
                            type="text"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="border border-gray-300 rounded-md px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                            required
                        />
                    </div>

                    {/* Submit & Cancel Buttons */}
                    <div className="flex justify-center space-x-4 pt-4">
                        <button type="button" onClick={onRequestClose} className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-400 transition">
                            Cancel
                        </button>
                        <button type="submit" className="bg-indigo-500 text-white px-6 py-2 rounded-md hover:bg-indigo-600 transition" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default AddAdunitForm;
